import useABTestValue from './useABTestValue'

const useIsNewArticleSummaryEnabled = () =>
  useABTestValue('showNewArticleSummary') === 'show'

export default useIsNewArticleSummaryEnabled
